// extracted by mini-css-extract-plugin
module.exports = {"root":"layout-module--root--1L1i8","skipLink":"layout-module--skipLink--S3sGH"};